"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscriptionProfileQuery = void 0;
var _fetching = require("@ori/fetching");
const subscriptionProfileQuery = exports.subscriptionProfileQuery = (0, _fetching.gql)`
  query subscriptionProfile {
    customer {
      subscriptionProfile {
        addressId
        address {
          area
          city
          country
          delivery
          district
          firstName
          id
          lastName
          locality
          province
          region
          streetAddress
          zipcode
        }
        deliveryChannel {
          address {
            addressId
            area
            city
            country
            district
            locality
            province
            region
            streetAddress
            zipcode
          }
          coordinates {
            latitude
            longitude
          }
          deliveryChannelId
          deliveryMethod
          description
          imageUrl
          isCodAllowed
          isLuxury
          orisalesId
          telephoneNumber
          workingHours
        }
      }
    }
  }
`;